import { Box, Flex } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import React from "react";
import { parseDateString } from "../../utils/formatDates";

interface DateRangeBoxProps {
  twoWeeksAgoDate: string;
  endDate: string;
}

export const DateRangeBox = ({
  twoWeeksAgoDate,
  endDate,
}: DateRangeBoxProps) => {
  return (
    <Flex justifyContent={"flex-end"} width={"100%"}>
      <Box
        margin={4}
        width={[null, null, null, "24%", "24%"]}
        justifyContent={"center"}
        fontSize={["xs", null, null, "sm", null]}
        borderRadius="2px"
        borderWidth="1px"
        backgroundColor={"#C2E0E2"}
        px={6}
        py={2}
      >
        <Flex direction={"column"} align={"center"} justifyContent={"center"}>
          <Text
            fontSize={"12px"}
            justifyContent={"center"}
            align={"center"}
            fontWeight={"semibold"}
          >
            {`${parseDateString(twoWeeksAgoDate)} - ${parseDateString(
              endDate
            )}`}
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
};
